import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { TableListRequest } from "../models/table-list-request.interface";
import { PaginatedListDataResponse } from "../models/paginated-list-data-response";

export interface TosTableConfig {
  selectedItem: string,
  tableListRequest: TableListRequest
}

@Injectable({
  providedIn: 'root'
})
export class TosTableService {
  private tosTableConfig = new BehaviorSubject<TosTableConfig>({
    selectedItem: '',
    tableListRequest: {} as TableListRequest,
  });

  private clickableTdEvent = new Subject<any>();

  // emitClickableTdEvent(column: any,record?: any) {
  //   this.clickableTdEvent.next({column,record});
  // }
  //
  // getClickableTdObservable() {
  //   return this.clickableTdEvent.asObservable();
  // }

  setTosTableConfig(data: TosTableConfig) {
    this.tosTableConfig.next(data);
  }

  getTosTableConfig(): Observable<TosTableConfig> {
    return this.tosTableConfig.asObservable();
  }
}
